import GA_EVENTS from './ga_constants';
import { setBehaviourEvent } from './ga_interface';

function notifyWhenProductRestockedFormSubmit(sku) {
    const category = GA_EVENTS.notifyMe.category;
    const action = GA_EVENTS.notifyMe.actions.notifyWhenProductRestockedFormSubmit;

    setBehaviourEvent({ category, action, label: sku });
}

function notifyWhenProductRestockedFormSubmitFailure(reason) {
    const category = GA_EVENTS.notifyMe.category;
    const action = GA_EVENTS.notifyMe.actions.notifyWhenProductRestockedFormSubmitFailure;

    setBehaviourEvent({ category, action, label: reason });
}

export {
    notifyWhenProductRestockedFormSubmit,
    notifyWhenProductRestockedFormSubmitFailure
};